import styled from "styled-components";
import { color } from "../../shared/styles";
import { Button } from "@mui/material";

export const ProductOrderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    height: 100%;
`;

export const TitleWrapper = styled.div`
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: space-between;
`;

export const TitleText = styled.div`
    font-size: 40px;
    font-weight: 700;
    line-height: 48px;
    word-wrap: break-word;
    color: ${color.secondary.CHARCOAL};

    gap: 16px;
    display: flex;
    align-items: center;
`;

export const StyledButton = styled(Button)`
    && {
        padding-top: 8px;
        padding-bottom: 8px;
        display: flex;
        justify-content: center;
        gap: 4px;
    }
`;
